import { c as _c } from "react/compiler-runtime";
import { CardContentBadge, CenterAligned } from "@opensea/ui-kit";
export function FavoriteItemBadge(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <CardContentBadge><button className="-right-2 -top-2 absolute flex size-20 justify-end pt-2 pr-2 focus-visible:outline-hidden" type="button"><CenterAligned className="aspect-square size-8 rounded-full bg-black/80 p-1.5">{children}</CenterAligned></button></CardContentBadge>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}